// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__3X3ED","obliqueLineWrap":"membershipbadge_obliqueLineWrap__1k4KC","obliqueLine":"membershipbadge_obliqueLine___lLtx"};